export const SalesLogo = () => (
  <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.8846" cy="12.8846" r="12.8846" fill="url(#paint0_linear_7216_442)" />
    <circle cx="12.8846" cy="12.8846" r="12.8846" fill="#FFA800" />
    <mask
      id="mask0_7216_442"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="26"
      height="26"
    >
      <circle cx="12.8846" cy="12.8846" r="12.8846" fill="#FFB800" />
    </mask>
    <g mask="url(#mask0_7216_442)">
      <path
        d="M21.5192 15.7899L9.59203 17.3285C9.56685 17.3318 9.54085 17.3318 9.51567 17.3285L-2.24577 15.7899C-2.54797 15.7899 -2.7925 15.5502 -2.7925 15.2537L-2.48945 7.95136C-2.48945 7.79376 -2.35947 7.66622 -2.19862 7.66622H21.472C21.6329 7.66622 21.7629 7.79376 21.7629 7.95136L22.0659 15.2537C22.0659 15.5502 21.8214 15.7899 21.5192 15.7899Z"
        fill="url(#paint1_linear_7216_442)"
      />
      <path
        d="M14.7138 7.74744H13.8202V5.70272C13.8202 5.4192 13.5895 5.18849 13.306 5.18849H6.12953C5.84601 5.18849 5.6153 5.4192 5.6153 5.70272V7.74744H4.72169V5.70272C4.72169 4.92609 5.3529 4.29489 6.12953 4.29489H13.306C14.0818 4.29489 14.7138 4.92609 14.7138 5.70272V7.74744Z"
        fill="url(#paint2_linear_7216_442)"
      />
      <path
        d="M21.5192 15.7899L9.6367 17.3228L9.59283 17.3285C9.57983 17.3301 9.56765 17.3309 9.55465 17.3309C9.54165 17.3309 9.52866 17.3301 9.51566 17.3285L-2.24578 15.7899C-2.35789 15.7899 -2.46187 15.7566 -2.5488 15.6997V25.3263C-2.5488 25.5709 -2.35049 25.7692 -2.10587 25.7692H21.3793C21.6239 25.7692 21.8222 25.5709 21.8222 25.3263V15.6997C21.7353 15.7566 21.6313 15.7899 21.5192 15.7899Z"
        fill="url(#paint3_linear_7216_442)"
      />
      <path
        d="M7.80352 15.5268L11.9094 15.5268C12.053 15.5268 12.1686 15.6444 12.1686 15.7882L12.1686 17.9856C12.1686 18.1304 12.052 18.247 11.9094 18.247L7.80352 18.247C7.65998 18.247 7.54437 18.1294 7.54437 17.9856L7.54437 15.7882C7.54437 15.6444 7.66094 15.5268 7.80352 15.5268Z"
        fill="url(#paint4_linear_7216_442)"
      />
    </g>
    <g filter="url(#filter0_d_7216_442)">
      <circle cx="21.4739" cy="19.7559" r="6.01329" fill="white" />
    </g>
    <path
      d="M24.9243 17.6441C24.4819 16.9677 23.8395 16.3976 23.1034 16.1126L22.8865 16.0403C22.6142 15.9594 22.3674 15.9254 22.142 15.9296C21.3464 15.9339 20.6997 16.5806 20.6997 17.3761C20.6997 17.708 20.8103 18.0143 20.9975 18.2568L20.9082 18.1462C21.1379 18.478 21.5081 18.8141 22.0271 19.2098C23.0609 19.9968 23.7331 20.6945 23.7884 21.5582C23.8012 21.673 23.8097 21.7922 23.8097 21.9155C23.8097 22.3537 23.7118 22.8217 23.5459 23.1493C23.5459 23.1493 23.4778 23.2684 23.5204 23.3152C23.5374 23.3322 23.5927 23.3493 23.6778 23.2982C24.1373 23.0046 24.5372 22.6218 24.852 22.1708C25.3115 21.5114 25.5625 20.7286 25.571 19.9245C25.5923 19.1076 25.3625 18.3206 24.9243 17.6441Z"
      fill="#FF8126"
    />
    <path
      d="M21.8649 20.6009L21.214 20.0777C19.8526 19.1034 19.1464 18.0568 19.5336 16.7635C19.5676 16.6444 19.6101 16.5295 19.6612 16.4189C19.6612 16.4189 19.759 16.2189 19.5463 16.3168C19.0996 16.555 18.6912 16.8784 18.3551 17.274C17.7722 17.9505 17.4276 18.8056 17.3808 19.699C17.334 20.5924 17.5808 21.4773 18.0913 22.2133C18.2998 22.4984 18.5508 22.7451 18.8358 22.9493C20.2696 23.9832 21.4991 23.4386 21.4991 23.4386C22.0989 23.1961 22.5244 22.6047 22.5244 21.9155C22.5201 21.3752 22.2649 20.8987 21.8649 20.6009Z"
      fill="#092540"
    />
    <defs>
      <filter
        id="filter0_d_7216_442"
        x="13.2739"
        y="11.556"
        width="16.3999"
        height="16.3999"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.09332" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.145098 0 0 0 0 0.25098 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7216_442" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7216_442" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_7216_442"
        x1="7.61364"
        y1="2.7331"
        x2="17.7065"
        y2="24.2949"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3971FF" />
        <stop offset="1" stopColor="#00BBE4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7216_442"
        x1="9.63671"
        y1="7.66622"
        x2="12.0321"
        y2="30.272"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.17" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7216_442"
        x1="9.71985"
        y1="4.97491"
        x2="9.71775"
        y2="7.74744"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.42" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_7216_442"
        x1="8.26862"
        y1="28.8608"
        x2="9.5658"
        y2="12.6894"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.125" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.28" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_7216_442"
        x1="10.2388"
        y1="17.6482"
        x2="10.2388"
        y2="14.3147"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
